import Axios from 'axios'
import _ from 'lodash'

class Language {
  constructor() {
    //public variable here
    this.url = window.location.href
  }

  getLanguage(app,langIndex){ //get language json file by passing param
      var langCode = "en";
      switch (langIndex) {
          case "cn": langCode = "cn"; break;
          case "id": langCode = "id"; break;
          case "vn": langCode = "vn"; break;
          case "th": langCode = "th"; break;
          case "kh": langCode = "kh"; break;
          case "my": langCode = "my"; break;
          case "lo": langCode = "lo"; break;
          case "hk": langCode = "hk"; break;
          case "ar": langCode = "ar"; break;
          case "fr": langCode = "fr"; break;
          case "ja": langCode = "ja"; break;
          case "es": langCode = "es"; break;
          case "pt": langCode = "pt"; break;
          case "tr": langCode = "tr"; break;
          case "ru": langCode = "ru"; break;
          case "kr": langCode = "kr"; break;
          case "mm": langCode = "mm"; break;
          case "hi": langCode = "hi"; break;
          case "mn": langCode = "mn"; break;
          case "bn": langCode = "bn"; break;
          case "ph": langCode = "ph"; break;
          case "bd": langCode = "bd"; break;
          case "ne": langCode = "ne"; break;
          default: langCode = "en"; break;
      }
      return Axios.get(window.langBaseURL + "/language_" + langCode + ".json?r=" + window.ver ).then(function ({data}){ 
        app.setLanguage(data);
      })
    
  }

}
export default Language



// WEBPACK FOOTER //
// ./src/modules/Language.js